import React from 'react';
import { outOfTheBoxComponents } from '../outOfTheBox/index.js';
import type { DSLeftNavigationT } from '../react-desc-prop-types.js';
import { LeftNavContext } from '../LeftNavigationContext.js';

export const OutOfTheBoxMapItem: React.ComponentType<DSLeftNavigationT.OutOfTheBoxMapItemT> = (props) => {
  const {
    item,
    item: { type, Component },
  } = props;
  const ctx = React.useContext(LeftNavContext);

  const finalItem = {
    ...item,
    itemOpts: {
      ...item.itemOpts,
    },
  };
  if (typeof type === 'string' && !!outOfTheBoxComponents[type]) {
    const OutOfTheBoxComponent = outOfTheBoxComponents[type];
    return <OutOfTheBoxComponent item={finalItem} ctx={ctx} />;
  }
  if (!Component) return null;
  // we expect an error to be threw if Component is not defined and type is not a valid out-of-the-box...
  return <Component item={item} ctx={ctx} />;
};
